import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-[#FFF8F0]" data-id="element-128">
      <Navbar data-id="element-129" />
      <main className="flex-grow" data-id="element-130">{children}</main>
      <Footer data-id="element-131" />
    </div>;
}